/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmConfigurationType from '@jira/spa-apps__admin-pages-products-jsm-configuration/src/ProductsJsmConfigurationType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmConfiguration: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJsmConfigurationType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-configuration", jiraSpaEntry: "async-products-jsm-configuration" */ '@jira/spa-apps__admin-pages-products-jsm-configuration/src/ProductsJsmConfigurationType.tsx'
		),
	),
);

const AsyncProductsJsmConfiguration = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmConfiguration}
		pageId="products-jsm-configuration"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmConfiguration;
